var TorsoModel = require('backbone-torso/modules/Model'),
    urls = require('./../../urls');

/**
 * Model to hold the ereg authentication method configuration data.
 *
 * @class EregAuthMethodConfigModel
 * @constructor
 */
module.exports = TorsoModel.extend({
  initialize: function (options) {
    options = options || {};
    this.serialNumber = options.serialNumber;
  },
  urlRoot: function () {
    return urls.tabletExtService + '/' + this.serialNumber + '/authentication-config';
  }
});
